import SiteAdmin from './SiteAdmin';

export default SiteAdmin;
